/**
 * FIXME: This should be replaced by the memoize module, but that requires a Node update.
 * NOTE: Do not use arguments that are hard to stringify (e.g. complex objects). If you need to, consider using WeakMap.
 **/
export const customMemoize = (callback, { maxAge }) => {
  const cache = new Map();
  return async function (...args) {
    const key = JSON.stringify(args);
    if (cache.has(key)) {
      const { value, timestamp } = cache.get(key);
      if (Date.now() - timestamp < maxAge) {
        return value;
      }
      cache.delete(key);
    }
    const result = await callback(...args);
    cache.set(key, { value: result, timestamp: Date.now() });
    return result;
  };
};
